import { render, staticRenderFns } from "./detailDrvRight.vue?vue&type=template&id=3ff69b78&scoped=true"
import script from "./detailDrvRight.vue?vue&type=script&lang=js"
export * from "./detailDrvRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff69b78",
  null
  
)

export default component.exports